<section class="notifications-shell">
  <div class="notifications-sticky">
    <header class="page-header page-header--no-search">
      <div class="page-header__title">
        <h2>{{ 'adminNotifications.title' | translate }}</h2>
        <p>{{ 'adminNotifications.subtitle' | translate }}</p>
      </div>
    </header>

    <nav class="notifications-nav" [attr.aria-label]="'adminNotifications.navigation' | translate">
      @for (link of links; track link.url) {
        <a
          [routerLink]="link.url"
          routerLinkActive="active"
          [class.active]="link.rulesNav ? rulesNavActive() : false"
          [routerLinkActiveOptions]="{ exact: !!link.rulesNav }">
          <i [class]="link.icon"></i>
          <span>{{ link.label | translate }}</span>
        </a>
      }
    </nav>
  </div>

  <main class="shell-content"><router-outlet></router-outlet></main>
</section>
